import {KeyValueObject} from './filter/key-value-object';
import {KeyValueCountObject} from './filter/key-value-count-object';

export class AdvancedFilter {
  productionYear: Array<KeyValueObject>;
  gearboxType: Array<KeyValueCountObject>;
  driveType: Array<KeyValueCountObject>;
  color: Array<KeyValueCountObject>;
  interiorType: Array<KeyValueCountObject>;
  enginePowerFrom: Array<KeyValueObject>;
  enginePowerTo: Array<KeyValueObject>;
  equipment: Array<KeyValueObject>;
  maxLength: Array<KeyValueObject>;
}
